import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { errorsMapping } from '../../constants/constants.js';
import { GET_ORDER_BY_TOKEN } from '../../operations/queries/get-order-by-token.js';

const useGetOrderByToken = ()=>{
    const [onComplete, setOnComplete] = React.useState(null);
    const [orderByToken, { called , loading , data , error: error1  }] = useLazyQuery(GET_ORDER_BY_TOKEN, {
        onError (error) {
            console.error(error);
            // General error for apollo error response
            toast.failed(errorsMapping.SOMETHING_WENT_WRONG);
        },
        onCompleted () {
            if (onComplete) onComplete();
        }
    });
    const getOrderByToken = React.useCallback((token)=>{
        if (token) {
            orderByToken({
                variables: {
                    token
                }
            });
        }
    }, [
        orderByToken
    ]);
    const queryResults = React.useMemo(()=>({
            data: data || undefined,
            called,
            loading,
            error: error1
        })
    , [
        called,
        data,
        error1,
        loading
    ]);
    return [
        getOrderByToken,
        queryResults,
        setOnComplete
    ];
};

export { useGetOrderByToken };
//# sourceMappingURL=use-get-order-by-token.js.map
